"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgNumCompact = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const ContextItem_1 = require("../../ContextItem");
const InputNumber_1 = require("../../../../2-inline-block/InputNumber");
const SliderHandle_1 = require("../../../../1-inline/SliderHandle");
const OptionalBadge_1 = require("./OptionalBadge");
const DefaultableToggle_1 = require("./DefaultableToggle");
const AutoValue_1 = require("./AutoValue");
const readStructured = (v, fallback) => {
    if (v && typeof v === 'object' && 'def' in v) {
        const s = v;
        return { def: !!s.def, value: Number(s.value) || fallback };
    }
    return { def: false, value: Number(v) || fallback };
};
const ArgNumCompact = ({ param, value, onChange }) => {
    const [t] = (0, use_t_1.useT)();
    const label = param.display?.() ?? t(param.name ?? param.id ?? '');
    const defaultable = !!param.defaultable;
    const fallback = param.default ?? 0;
    const s = readStructured(value, fallback);
    const def = defaultable && s.def;
    const emit = (next) => {
        if (defaultable)
            onChange(next);
        else
            onChange(next.value);
    };
    const setControlValue = (n) => emit({ def: false, value: n });
    const enterCustom = () => emit({ def: false, value: s.value });
    const revertToAuto = () => emit({ def: true, value: s.value });
    const customControl = (React.createElement("div", { style: { width: 120, margin: '-5px 0' } },
        React.createElement(InputNumber_1.InputNumber, { inputProps: { size: -3 }, min: param.min, max: param.max, step: param.step, decimals: param.decimals, dragSensitivity: param.dragSensitivity, dragAxis: param.dragAxis, value: s.value, drag: true, dragHandle: React.createElement(SliderHandle_1.SliderHandle, null), onChangeEnd: setControlValue })));
    const autoDisplay = (React.createElement(AutoValue_1.AutoValue, { onClick: enterCustom },
        React.createElement("span", { style: { fontVariantNumeric: 'tabular-nums' } }, fallback)));
    const right = defaultable ? (React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center', gap: 4, marginRight: -8 } }, def ? (React.createElement(React.Fragment, null,
        React.createElement(DefaultableToggle_1.DefaultableToggle, { def: true, onClick: enterCustom }),
        autoDisplay)) : (React.createElement(React.Fragment, null,
        React.createElement(DefaultableToggle_1.DefaultableToggle, { def: false, onClick: revertToAuto }),
        customControl)))) : (React.createElement("div", { style: { width: 120, marginRight: -8 } }, customControl));
    return (React.createElement(ContextItem_1.ContextItem, { icon: param.icon?.(), control: true, inset: true, right: right },
        React.createElement("span", null,
            label,
            param.optional && React.createElement(OptionalBadge_1.OptionalBadge, null))));
};
exports.ArgNumCompact = ArgNumCompact;
